import { useState, PropsWithChildren } from 'react';
import Menu from '@creditflowresearch/uilib/LegacyMenu';
import LockedFeaturePopupContent from './LockedFeaturePopupContent';

interface IProps extends PropsWithChildren {
  name: string,
  content: React.ReactNode,
  popoverContentClassName?: string,
  className?: string,
  isRestricted?: boolean,
  usePortal?: boolean,
  triggerEvent?: 'click' | 'hover',
}

const LockedFeaturePopup = ({
  children,
  name,
  content,
  popoverContentClassName,
  className,
  isRestricted = true,
  usePortal = false,
  triggerEvent = 'click',
}: IProps) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!isRestricted) {
    return <>{ children }</>;
  }

  const popupContent = (
    <LockedFeaturePopupContent
      title="Upgrade to access"
      subtitle={ content }
      description={ `Your plan does not include ${ name } coverage. Upgrade for access.` }
      onClose={ () => setIsVisible((prev) => !prev) }
    />
);

  return (
    <Menu
      popoverContentClassName={ popoverContentClassName }
      className={ className }
      isVisible={ isVisible }
      setIsVisible={ setIsVisible }
      content={ popupContent }
      offsetOptions={ { mainAxis: 0 } }
      triggerEvent={ triggerEvent }
      usePortal={ usePortal }
    >
      { children }
    </Menu>
);
};

export default LockedFeaturePopup;
